import * as React from 'react'
import App from './App'
import {muiTheme} from './conf/mui-theme'
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core'
import MomentUtils from '@date-io/moment'
import { MuiPickersUtilsProvider } from 'material-ui-pickers'
import {ToastProvider} from "./shared/Toast";
import { GlobalProgressProvider } from './shared/GlobalProgress'

class Main extends React.Component<{}, {}> {

  render() {
    return (
      <MuiThemeProvider theme={createMuiTheme(muiTheme())}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <GlobalProgressProvider>
            <ToastProvider>
              <App/>
            </ToastProvider>
          </GlobalProgressProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    )
  }
}

export default Main



// WEBPACK FOOTER //
// ./src/Main.tsx